import header from './header';
import textBlock from './text-block';
import whitespaces from './whitespaces';
import overlay from './overlay';
import responsiveAttribute from './responsive-attribute';

const initializeHandlers = () => {
  responsiveAttribute.init();
  header.init();
  textBlock.init();
  whitespaces.init();
  overlay.init();
};

export default initializeHandlers;
